import styled from 'styled-components'
import media from 'styles/tools/media'
import content from 'styles/_objects/content'
import rem from 'styles/tools/rem'

import { title20GalanoBold, txt14OpenSans } from 'styles/settings/types'
import { lightestBlue, darkGrey, nearWhite } from 'styles/settings/colors'

export const Content = styled.div`
  ${content};
  display: flex;
`

export const Item = styled.div`
  ${media.large`
    width: 25%;
  `};
`

export const Label = styled.label`
  color: ${darkGrey};
  font-family: OpenSans;
  font-size: ${rem('12px')};
  font-weight: 200;
  letter-spacing: ${rem('0.4px')};
  line-height: 1;
  pointer-events: none;
  text-transform: uppercase;
  white-space: nowrap;
  display: block;
  margin-bottom: ${rem('15px')};
`

export const Title = styled.p`
  ${title20GalanoBold};

  letter-spacing: ${rem('0.3px')};
  margin: 0;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
`

export const Text = styled.p`
  ${txt14OpenSans};
  font-weight: 500;
  color: ${darkGrey};
  line-height: ${rem('1.2px')};
`

export const StatusContainer = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;

  ${media.small`
        margin-top: ${rem('20px')};
    `};
`

export const ListItem = styled.li`
  position: relative;
  padding: ${rem('30px')} 0 ${rem('23px')} 0;
  border-bottom: ${rem('1px')} solid ${lightestBlue};
  color: ${darkGrey};
  justify-content: center;

  :hover {
    cursor: pointer;
    background-color: ${nearWhite};
  }

  .download-button {
    position: absolute;
    top: ${rem('30px')};
    right: ${rem('30px')};
    display: none;
  }

  ${media.small`
        ${props =>
          props.first &&
          `
            ${Title} {
                font-size: ${rem('36px')};
            }
        `}
    `};
`



// WEBPACK FOOTER //
// ./src/app/elements/RechargeListItem/styles.js